import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

const Logo = ({ isHamburgerActive = false }) => (
	<a className='underline-none' href='https://rocketprofit.com'>
		<div className={cn({
			'rocket-logo-market': true,
			'font-blogger-sans-regular': true,
			'inverse-color': isHamburgerActive
		})}>
			<span>Rocket</span>
			<span>Profit</span>
		</div>
	</a>
);

Logo.propTypes = {
	isHamburgerActive: PropTypes.bool
};

export default Logo;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/logo/main.js